import React from 'react';
import { withStyles } from 'vopay';
import styles from './RadioCard.module.scss';

const classes = withStyles(styles);

interface RadioCardProps {
  children: React.ReactNode;
  name: string;
  value: string;
  checked?: boolean;
  onChange?: (value: string) => void;
  disabled?: boolean;
  customIndicator?: React.ReactNode;
}

const RadioCard: React.FC<RadioCardProps> = ({
  children,
  name,
  value,
  checked = false,
  onChange,
  disabled = false,
  customIndicator,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!disabled && onChange) {
      onChange(event.target.value);
    }
  };

  const handleClick = () => {
    if (!disabled && onChange) {
      onChange(value);
    }
  };

  return (
    <label
      className={`${classes('radioCard')} ${checked ? classes('checked') : ''} ${disabled ? classes('disabled') : ''}`}
      onClick={handleClick}
    >
      <input
        type="radio"
        name={name}
        value={value}
        checked={checked}
        onChange={handleChange}
        disabled={disabled}
        className={classes('radioInput')}
      />
      <div className={classes('radioContent')}>{children}</div>
      {customIndicator ? (
        <div className={classes('customIndicator')}>{customIndicator}</div>
      ) : (
        <div className={classes('radioIndicator')}>
          <div className={classes('radioIndicatorInner')} />
        </div>
      )}
    </label>
  );
};

export default RadioCard;
